import Toolbar from "@mui/material/Toolbar";
import { BemViver } from "../assets/images";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar/AppBar";
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import { useDrawerContext } from "../contexts/DrawerContext";
import { useTopBarContext } from "../contexts/TopBarContext";

const drawerWidth = 250;

interface AppBarProps extends MuiAppBarProps {
  open: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export function TopBar() {
  const { open } = useDrawerContext();

  const { title } = useTopBarContext();

  return (
    <AppBar position="fixed" open={open} sx={{ backgroundColor: "#EDEDED" }}>
      <Toolbar>
        <img
          src={BemViver}
          alt="logo"
          style={{ width: "80px", marginRight: "40px" }}
        />

        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ fontFamily: "inherit", fontWeight: "bold", color: "#19501A" }}
        >
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
